import React, { memo, useCallback, useEffect } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, message } from "antd";
import {
  useGetAuthorityFindPermissions,
  useGetAuthorityGetRoleById,
  usePutAuthorityUpdateRole,
} from "core";
import LoadingView from "../../atoms/loadingView";
import { useParams } from "react-router-dom";

const NAME = "name";
const PERMISSIONS = "permissions";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditRole = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const { data: { data } = {}, isFetching } = useGetAuthorityFindPermissions();
  const { id } = useParams();
  
  const { data:dataRole , isFetching: isFetchingRole,isFetched } =
    useGetAuthorityGetRoleById({
      roleId:id||""
    });




   const permissions=dataRole?.data?.permissions?.map((item:any)=>{return item.name})
    
    useEffect(() => {
      if (isFetched) {
        reset({
          name: dataRole?.data?.name,
          permissions:permissions
        });
      }
      
  }, [dataRole]);

  const methods = useForm({
    defaultValues: {
      name: "",
      permissions: [],
    },
  });

  const { handleSubmit, reset } = methods;
  const { mutate, isPending } = usePutAuthorityUpdateRole({
    onSuccess: () => {
      messageApi.open({
        type: 'success',
        content: i18n.t('done'),
      });
      reset();
    },
  });

  const onSubmit = useCallback(
    ({ name, permissions }: { name: any; permissions: any }) => {
      mutate({
        requestBody: {
          roleId:Number(id) ,
          name: name,
          permissions: permissions,
        },
      });
    },
    []
  );

  const permissionsItem = data?.map((item: { name: string }) => {
    return {
      value: item.name,
      label: item.name,
    };
  });
  return (
    <>
      {contextHolder}

      <LoadingView isLoading={isFetchingRole}>
        <Card title={i18n.t("editRole")}>
          <FormProvider {...methods}>
            <Form
              {...layout}
              name="nest-messages"
              onFinish={handleSubmit(onSubmit)}
            >
              <Form.Item>
                <Controller name={NAME}>
                  <Input placeholder={i18n.t("roleName")} />
                </Controller>
              </Form.Item>
              <LoadingView isLoading={isFetching}>
                <Form.Item>
                  <Controller name={PERMISSIONS}>
                    <SelectBox
                      mode="tags"
                      label={i18n.t("permissions")}
                      options={permissionsItem}
                      placeholder={i18n.t("enter")}
                    />
                  </Controller>
                </Form.Item>
              </LoadingView>
              <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
                <Button
                  style={{ width: "100px" }}
                  type="primary"
                  isLoading={isPending}
                  htmlType="submit"
                >
                  {i18n.t("update")}
                </Button>
              </Form.Item>
            </Form>
          </FormProvider>
        </Card>
      </LoadingView>
    </>
  );
});
export { EditRole };
